// extracted by mini-css-extract-plugin
module.exports = {"container":"small_text_button-module__container--2IDCr"};